/* 工作流模块api */
import http from '@util/http';
import { workflow } from './req';

/**
 * 获取工作流模板列表
 * @param {} params
 * @returns {}
 */
export async function queryWorkflowTemplateList(params) {
  return http.get(workflow.WORKFLOW_TEMPLATE_LIST, params);
}

/**
 * 获取工作流模板详情
 * @param {} uuid
 * @returns {}
 */
export async function queryWorkflowTemplateInfo(uuid) {
  return http.get(workflow.WORKFLOW_TEMPLATE_INFO, { uuid });
}

/**
 * 保存工作流模板
 * @param {} params
 * @returns {}
 */
export async function querySaveWorkflowTemplate(params) {
  return http.post(workflow.WORKFLOW_TEMPLATE_SAVE, params);
}

/**
 * 删除工作流模板
 * @param {} uuid
 * @returns {}
 */
export async function queryDeleteWorkflowTemplate(uuid) {
  return http.get(workflow.WORKFLOW_TEMPLATE_DELETE, { uuid });
}

/**
 * 获取个人任务列表
 */
export async function queryTaskList(params) {
  return http.get(workflow.GET_TASK_LIST, params);
}

export async function queryDoneTaskList(params) {
  return http.get(workflow.GET_DONE_TASK_LIST, params);
}



// WEBPACK FOOTER //
// ./src/api/workflow.js